import React from 'react'
import context from '@/context'
import { ModalBody, Form, FormGroup, Label } from 'reactstrap'
import Resx from '@/components/Resx'
import { DropDownList } from '@/components/dropDownList'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ValidationBoundary, ValidationState, Validator } from '@/components/validation'
import ErrorBoundary from '@/components/ErrorBoundary'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'

const initialState = {
  selectedInstitution: null
}

class InstitutionDialog extends React.Component {
  constructor (props, context) {
    super(props, context)
    this.state = {
      ...initialState
    }
  }
  render () {
    return (
      <ValidationBoundary>
        <BasicHeader title='Institutions.SelectInstitution' {...this.props} />
        <ModalBody>
          <ErrorBoundary>
            <Form>
              <FormGroup>
                <Label><Resx name='Institutions.Institution' /></Label>
                <Validator name='institution' value={this.state.selectedInstitution} required>
                  <DropDownList
                    dataSource={context.api.institutionService.getLookup}
                    onChange={({ item }) => this.setState({ selectedInstitution: item })}
                    value={this.state.selectedInstitution}
                  />
                </Validator>
              </FormGroup>
            </Form>
          </ErrorBoundary>
        </ModalBody>
        <ValidationState render={({ isValid }) =>
          <ConfirmFooter primaryButtonText='Common.SaveAndClose' icon='save' {...this.props} onAction={() => this.props.onAction({ ...this.state.selectedInstitution })} disabled={!isValid} />
        } />
      </ValidationBoundary>
    )
  }
}
export default {
  component: InstitutionDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/institution.js